import type { UseFormReturn } from 'react-hook-form';

import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';

import InputField from '../../atoms/InputField/InputField.jsx';
import { UserModalType } from './validation.js';

export type EmailViewProps = {
  formInstance: UseFormReturn<UserModalType>;
};

const EmailView = ({ formInstance }: EmailViewProps) => {
  const { t } = useTranslation('@myn/permissions');

  return (
    <div>
      <div className="flex flex-col gap-1">
        <p className={typographyVariants({ variant: 'bodyLong01' })}>
          {t('Enter the email of the user you would like to add.')}
        </p>
        <InputField
          placeholder={t('Enter email')}
          error={!!formInstance.formState.errors.email?.message}
          helperText={formInstance.formState.errors.email?.message}
          onChange={() => {
            formInstance.clearErrors('isActive');
            formInstance.clearErrors('email');
          }}
          autoFocus={true}
          name="email"
          data-dd-action-name="User modal: email"
        />
      </div>
    </div>
  );
};

export default EmailView;
